export const regions = ["日本", "中国", "欧美", "韩国"];

export const years = [2026, 2025, 2024, 2023, 2022, 2021];

export const sortOptions = [
  { value: "popular", label: "最热门" },
  { value: "latest", label: "最近更新" },
  { value: "rating", label: "评分最高" },
  { value: "newest", label: "年份最新" },
] as const;

export type SortValue = (typeof sortOptions)[number]["value"];